export const Images = {
  // ON SIGHT
  icon_home: './assets/images/onsight_icon_home.svg',
  icon_group: './assets/images/onsight_icon_group.svg',
  icon_notification: './assets/images/onsight_icon_notification.svg',
  icon_forms: './assets/images/onsight_icon_form.svg',
  pending_actions: './assets/images/pending_actions.svg',
  fact_check: './assets/images/fact_check.svg',
  icon_settings: './assets/images/onsight_icon_settings.svg',
  // GENERALS
  logo: './assets/images/logo_onsight.png',
  arrow_next: './assets/images/arrow_next.png',
  arrow_next_active: './assets/images/arrow_next_active.png',
  checkbox_check: './assets/images/checkbox_check.png',
  signature: './assets/images/signature.png',
  notifications: './assets/images/notifications.svg',
  notifications_open: './assets/images/notifications_open.svg',
  close: './assets/images/close.png',
  face: './assets/images/face.png',
  imageQR: './assets/images/imageQR.png',
  download: './assets/images/download.png',
  // EN
  header1_en: './assets/images/header1_en.jpg',
  header1_en_m: './assets/images/header1_en_m.jpg',
  header2_en: './assets/images/header2_en.jpg',
  header2_en_m: './assets/images/header2_en_m.jpg',
  // ES
  header1_es: './assets/images/header1_es.jpg',
  header1_es_m: './assets/images/header1_es_m.jpg',
  header2_es: './assets/images/header2_es.jpg',
  header2_es_m: './assets/images/header2_es_m.jpg',
  loader: './assets/images/loader.svg',
}
